import * as pxp from 'lib/pxp'

/**
 * FEAT. : Multi item cart for PayPal shops.
 * This is for controlling paypal shops multi item cart experience.
 * https://www.msmaster.qa.paypal.com/elmo/experiment/122453
 * TODO: (Pending to put production URL)
 */
export function hasMultiItemCartShops() {
  return pxp.isTreatment('Trmt_p2p_shops_multi_item_cart_exp')
}

/**
 * FEAT. : Allow guest payment.
 * This is to allow guest payment or force user to sign up based on product requirements.
 * In accordance with risk: 1. any email can be used to make payment, 2. there is no way to give user receipt.
 * https://www.msmaster.qa.paypal.com/elmo/experiment/122859
 * TODO: (Pending to put production URL)
 */
export function hasAllowGuestPayment() {
  return pxp.isTreatment('Trmt_p2p_shop_allow_guest_paymemt')
}
